import http from './http';
import { handleResponse } from '@/shared/utils/promise-helpers';

/**
 * Funcionalidade: Lista todos os colegas (ramais,agentes,supervisores)
 * Retorna todos os colegas a partir dos parâmetros enviados
 * @requestType GET
 * @param {*} params
 * @returns json
 */
export const getColleaguesList = (params) =>
  http.get('/internal-call/list', { params }).then(handleResponse);

/**
 * Funcionalidade: Busca os status dos os colegas (ramais,agentes,supervisores) enviados
 * Retorna os status dos colegas enviados
 * @requestType POST
 * @param {*} params
 * @returns json
 */
export const getColleaguesListStatus = (params) =>
  http.post('/internal-call/status', params).then(handleResponse);

/**
 * Funcionalidade: Realiza a ligação para outro colega
 * Ação para realizar ligação
 * @requestType POST
 * @param {*} params
 * @returns json
 */
export const call = (params) =>
  http.post('/internal-call/call', params).then(handleResponse);

/**
 * Funcionalidade: Desliga a ligação em andamento
 * Ação para desligar a ligação
 * @requestType POST
 * @param {*} params
 * @returns json
 */
export const hangupCall = (params) =>
  http.post('/internal-call/hangup', params).then(handleResponse);
